import { Link } from "react-router-dom";
import { Clock, MessageCircle, MapPin, Phone } from "lucide-react";
import Logo from "./Logo";
import { waLink, WHATSAPP_DISPLAY } from "@/config";

export const Footer = () => (
  <footer className="border-t border-white/10 bg-[#070707]" data-testid="site-footer">
    <div className="max-w-7xl mx-auto px-5 md:px-8 pt-14 md:pt-20 grid grid-cols-1 md:grid-cols-3 gap-12">
      <div>
        <Logo />
        <p className="mt-5 text-white/50 text-sm leading-relaxed max-w-xs">
          India ka apna used two-wheeler showroom. Verified bikes, fair prices, paperwork handled — bas ride karo.
        </p>
      </div>
      <div>
        <h4 className="font-display uppercase tracking-widest text-xs text-volt mb-5">Explore</h4>
        <ul className="space-y-3 text-sm">
          <li><Link to="/inventory" data-testid="footer-link-inventory" className="text-white/60 hover:text-volt transition-colors duration-300">Browse Inventory</Link></li>
          <li><Link to="/sell" data-testid="footer-link-sell" className="text-white/60 hover:text-volt transition-colors duration-300">Sell Your Bike</Link></li>
          <li><Link to="/#exchange" data-testid="footer-link-exchange" className="text-white/60 hover:text-volt transition-colors duration-300">Exchange & Upgrade</Link></li>
        </ul>
      </div>
      <div>
        <h4 className="font-display uppercase tracking-widest text-xs text-volt mb-5">Contact</h4>
        <ul className="space-y-4 text-sm">
          <li className="flex items-center gap-3 text-white/60">
            <Phone className="w-4 h-4 text-volt shrink-0" />
            <span data-testid="footer-phone">{WHATSAPP_DISPLAY}</span>
          </li>
          <li className="flex items-start gap-3 text-white/60">
            <MapPin className="w-4 h-4 text-volt shrink-0 mt-0.5" />
            <a
              href="https://www.google.com/maps/search/?api=1&query=Shop+No.+11%2C+Shrushti+Heights%2C+4th+Road%2C+Opp+Shani+Mandir%2C+Nalasopara+West"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-address"
              className="hover:text-volt transition-colors duration-300"
            >
              Shop No. 11, Shrushti Heights, 4th Road,<br />
              Opp Shani Mandir, Nalasopara West
            </a>
          </li>
          <li className="flex items-center gap-3 text-white/60">
            <Clock className="w-4 h-4 text-volt shrink-0" />
            <span data-testid="footer-timing">Open all 7 days, 10 AM to 9:30 PM</span>
          </li>
          <li>
            <a
              href={waLink("Hi Deal 2 Wheel!")}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-whatsapp-link"
              className="inline-flex items-center gap-2 text-volt hover:underline"
            >
              <MessageCircle className="w-4 h-4" /> Chat on WhatsApp
            </a>
          </li>
        </ul>
      </div>
    </div>
    <div className="max-w-7xl mx-auto px-5 md:px-8 mt-12 mb-14 md:mb-20">
      <div className="border border-white/10 overflow-hidden" data-testid="footer-map">
        <iframe
          title="Deal 2 Wheel showroom location"
          src="https://maps.google.com/maps?q=Shop%20No.%2011%2C%20Shrushti%20Heights%2C%204th%20Road%2C%20Opp%20Shani%20Mandir%2C%20Nalasopara%20West&t=&z=15&ie=UTF8&iwloc=&output=embed"
          className="w-full h-64 md:h-72 grayscale invert-[0.92] contrast-[0.9] opacity-90"
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          allowFullScreen
        />
      </div>
    </div>
    <div className="border-t border-white/10 py-6">
      <p className="text-center text-xs text-white/30 tracking-widest uppercase">
        © {new Date().getFullYear()} Deal 2 Wheel — Sell. Buy. Exchange.
      </p>
    </div>
  </footer>
);

export default Footer;
